const quizStatuses = {
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    NOT_STARTED: 'NOT_STARTED',
};

export default quizStatuses;
